module.exports = __webpack_public_path__ + "static/media/Strawberry_Blurred.f53bb498.png";